export default __webpack_public_path__ + "static/media/typeP_low_lamp.b5365cfe.png";